module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.eot?021f7cf49ba1be6de4001de27126548a";